export const complaintsMapped = (arr = []) => {
    return arr.map((item) => {
        return { label: item.name, value: item.id }
    });
};